import { FormattedMessage } from "react-intl";
import FileBrowser from "@/components/FileBrowser";
import FileViewer from "@/components/FileBrowser/FileViewer";
import { intoPath } from "@/utils/url";
import { useLocation } from "@/utils/location";
import { getCompetitionCodePath, parseFileKind } from "@/utils/routing";
import { graphql, Environment } from "react-relay";
import { LoaderArgs } from "@/utils/route";
import { CompetitionCodeReadmePageQuery as CompetitionCodeReadmePageQueryType } from "./__generated__/CompetitionCodeReadmePageQuery.graphql";
import { preload, usePreloaded } from "@/utils/relay";
export default function CompetitionCodeReadmePage() {
  const location = useLocation();
  const {
    query,
    variables: { slug, fileKind, owner },
  } = useCompetitionCodeReadmePageQuery();
  const readme =
    query.competitionBySlug?.useCase.latest?.fileByKind?.browse.readMeta;
  const file = query.competitionBySlug?.useCase.latest?.fileByKind;
  const rootPath = intoPath(
    getCompetitionCodePath(owner, slug, fileKind),
    location.search,
  );
  return (
    <div className="space-y-6">
      {file && <FileBrowser root={rootPath} file={file} />}
      {readme?.kind == "FILE" ? (
        <FileViewer entry={readme} disableScroll={true} />
      ) : (
        <div className="text-center text-gray-500">
          <FormattedMessage defaultMessage="No README.md found" />
        </div>
      )}
    </div>
  );
}
const CompetitionCodeReadmePageQuery = graphql`
  query CompetitionCodeReadmePageQuery(
    $owner: String!
    $slug: String!
    $fileKind: ProjectVersionFileKind!
  ) {
    competitionBySlug(slug: $slug) {
      id
      event(slug: $owner) {
        event {
          slug
        }
      }
      useCase {
        latest {
          fileByKind(kind: $fileKind) {
            ...FileBrowserFragment
            browse {
              readMeta(path: "README.md") {
                kind
                ... on FileBrowserFileEntry {
                  ...FileViewerFragment
                }
              }
            }
          }
        }
      }
    }
  }
`;
export const loader = (environment: Environment) => {
  return ({ params: { slug: owner, track: slug, kind } }: LoaderArgs) => {
    if (!slug || !owner) {
      throw new Response("No slug", { status: 500 });
    }
    return preload<CompetitionCodeReadmePageQueryType>(
      environment,
      CompetitionCodeReadmePageQuery,
      {
        owner,
        slug,
        fileKind: parseFileKind(kind),
      },
    );
  };
};
const useCompetitionCodeReadmePageQuery = () =>
  usePreloaded<CompetitionCodeReadmePageQueryType>();
